import React, { useEffect, useState } from 'react'
import { algoliaIndex } from '@/lib/algolia'
import { SearchRadiusInMeters } from '../../../constants/searchRadius'
import CenterCarousel from '../../molecules/CenterCarousel/CenterCarousel'
import logger from '../../../utils/logger'
const HORIZONTAL_SCROLL_COUNT = 3

export default function CentersNearYou({
  condition = 'Depression',
  shouldDefaultRegionalize = false
}) {
  const [centers, setCenters] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    algoliaIndex
      .search('', {
        aroundLatLngViaIP: true,
        aroundRadius: SearchRadiusInMeters.DEFAULT,
        filters: `sponsor_tier:1 OR sponsor_tier:'1' OR sponsor_tier:2 OR sponsor_tier:"2" AND site:lux`,
        hitsPerPage: 20
      })
      .catch((e) => {
        logger.error('error loading centersNearYou block', e)
      })
      .then(({ hits }) => {
        setCenters(hits)
        setLoading(false)
      })
  }, [])

  const title = `${
    shouldDefaultRegionalize ? 'Centres' : 'Centers'
  } Offering ${condition} Treatment Near You`

  return (
    <CenterCarousel
      centers={centers}
      sectionHeading={title}
      isLoading={loading}
      scrollItemCount={HORIZONTAL_SCROLL_COUNT}
      containerId="centersNearYou"
      termTitle={condition}
    />
  )
}
